import { useEffect, useLayoutEffect, useRef } from "react";
import { Box, Fade, css } from "@mui/material";
import styled from '@emotion/styled/macro';
import useCanvasRulersTool from "../store/canvas-rulers";
import { useCropperStore } from "../store/cropper/cropper-store";
import PassThroughDiv from "./PassThroughDiv";

const CanvasRulerMeasure = styled(Box, {})`
  background: ${props => props.theme.palette.grey[700]};
  position: absolute;
`;

const CanvasRuler = styled(Box, {
  shouldForwardProp: prop => !['anchor'].includes(prop),
})`
  --size: 1em;
  color: #fff;
  font-size: var(--size);
  background: ${props => props.theme.palette.grey[800]};
  height: ${props => props.anchor === 'top' ? 'var(--size)' : '100%'};
  width: ${props => props.anchor === 'top' ? '100%' : 'var(--size)'};
  line-height: var(--size);
  top: 0;
  left: 0;
  position: absolute;
  display: flex;
  justify-content: center;
  pointer-events: all;

  ${props => props.anchor === 'left' && css`
    > ${CanvasRulerMeasure} {
      left: 0;
      transform: rotate(-90deg);
      transform-origin: top left;
    }
  `}
`;

export default function CanvasRulers() {
  const cropperStore = useCropperStore();
  const {shown, setShown} = useCanvasRulersTool();

  const rulerTop = useRef();
  const rulerTopSubs = useRef();
  const rulerLeft = useRef();

  useLayoutEffect(() => {

    if ( cropperStore?.element?.cropper ) {
      const createRulers = () => [
        rulerTop.current,
        rulerLeft.current,
      ].forEach((ruler, index) => {
        const isTop = index <= 0;

        const { cropBoxData } = cropperStore.element.cropper;

        /** -------- styles ---------- */
        ruler.firstElementChild.style.height = isTop ? `100%` : 'auto';
        ruler.firstElementChild.style.width = `${cropBoxData[isTop ? 'width' : 'height']}px`;

        if ( ! isTop ) {
          ruler.firstElementChild.style.top = `${cropBoxData.top + cropBoxData.height}px`;
        }

        /** -------- subs ---------- */
        const centimeters = isTop ? cropperStore.preset.width : cropperStore.preset.height;
        const cropBoxSide = cropBoxData[ isTop ? 'width' : 'height' ];
        const pixelPerCM = Math.floor( cropBoxSide / centimeters );

        // console.log(centimeters);

        Array.from({ length: centimeters }).forEach((_, i) => {
          
        });

      });

      createRulers();
      window.addEventListener('resize', createRulers);
      return () => window.removeEventListener('resize', createRulers);
    }

  }, [
    cropperStore.preset.width,
    cropperStore.preset.height, 
    cropperStore.element
  ]);
  
  return (
    <>
      <Fade in={shown && cropperStore.isCropperReady()}>
        <PassThroughDiv
          position="absolute"
          // style={{}}
        >
          <CanvasRuler ref={rulerTop} anchor="top">
            <CanvasRulerMeasure>
              ruler top
            </CanvasRulerMeasure>
          </CanvasRuler>
          <CanvasRuler ref={rulerLeft} anchor="left">
          <CanvasRulerMeasure>
              ruler left
            </CanvasRulerMeasure>
          </CanvasRuler>
        </PassThroughDiv>
      </Fade>
    </>
  );
}
